import { render, staticRenderFns } from "./DocutaxRequestReply.vue?vue&type=template&id=cf908c6a&"
import script from "./DocutaxRequestReply.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequestReply.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxRequestReply.vue?vue&type=style&index=0&id=cf908c6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports